import { render } from "./FontSizeComponent.vue?vue&type=template&id=2d30fd62"
import script from "./FontSizeComponent.vue?vue&type=script&lang=js"
export * from "./FontSizeComponent.vue?vue&type=script&lang=js"

import "./FontSizeComponent.vue?vue&type=style&index=0&id=2d30fd62&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__